import { SiderProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { FC } from "react";

export type IncSiderProps = SiderProps;

export const IncSider: FC<IncSiderProps> = (props) => <Sider {...props} />;
